import { Box, Typography } from "@mui/material";
import { StatusChip } from "./StatusChip";
import { ChecklistSection } from "./ChecklistSection";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import axiosInstance from "../../../utils/axiosConfig";
import { scheduleData } from "../utils/constants";

export const ScheduleDetails = ({
  selectedSchedule,
  currentUser,
  localNotes,
  handleChecklistItemChange,
  handleLocalNotesChange,
  handleSaveNotes,
}) => {
  const { t } = useTranslation();
  const [technicianSignature, setTechnicianSignature] = useState(null);

  useEffect(() => {
    const fetchTechnicianSignature = async () => {
      const response = await axiosInstance.get(
        `/users/${selectedSchedule.user_id}`
      );
      const userData = await response.data;
      setTechnicianSignature(userData.signature_url);
    };

    if (selectedSchedule?.user_id) {
      fetchTechnicianSignature();
    }
  }, [selectedSchedule]);

  const scheduleData_ = scheduleData(selectedSchedule, technicianSignature);

  return (
    <div
      style={{
        flex: window.innerWidth <= 768 ? "1" : "0 0 40%",
        width: window.innerWidth <= 768 ? "100%" : "auto",
      }}
    >
      {selectedSchedule?.service_started_at && (
        <Typography variant="body1" sx={{ mt: 1 }}>
          {t("serviceStarted")}:{" "}
          {new Date(selectedSchedule.service_started_at).toLocaleString()}
        </Typography>
      )}
      {selectedSchedule?.service_completed_at && (
        <Typography variant="body1" sx={{ mt: 1 }}>
          {t("serviceCompleted")}:{" "}
          {new Date(selectedSchedule.service_completed_at).toLocaleString()}
        </Typography>
      )}
      <Typography variant="h5" className="form-title">
        {t("scheduleDetails")}
        {selectedSchedule && currentUser !== "admin" && (
          <StatusChip status={selectedSchedule.status} />
        )}
      </Typography>

      <Typography variant="h6">{selectedSchedule.description}</Typography>
      <Typography variant="h6">
        {t("elevator")}: {selectedSchedule.elevator.identifier}
      </Typography>

      <Box sx={{ mt: 2 }}>
        <Typography variant="h6">{t("clientInformation")}</Typography>
        <Typography variant="body1">
          {t("client")}: {selectedSchedule.client.name}
        </Typography>
        <Typography variant="body1">
          {t("location")}: {selectedSchedule.elevator.building.location.name}
        </Typography>
        <Typography variant="body1">
          {t("address")}: {selectedSchedule.elevator.building.location.address}
        </Typography>
        <Typography variant="body1">
          {t("phone")}: {selectedSchedule.elevator.building.location.phone}
        </Typography>
      </Box>

      <ChecklistSection
        selectedSchedule={selectedSchedule}
        currentUser={currentUser}
        localNotes={localNotes}
        handleChecklistItemChange={handleChecklistItemChange}
        handleLocalNotesChange={handleLocalNotesChange}
        handleSaveNotes={handleSaveNotes}
        scheduleData={scheduleData_}
        technicianSignature={technicianSignature}
      />
    </div>
  );
};
